export default __webpack_public_path__ + "static/media/certificate1.d68f6497.svg";